import { createReducer, on } from '@ngrx/store';
import * as actions from './ui.actions';

export interface State {
  isLoading: Boolean;
}

export const initialState: State = {
  isLoading: false,
}

const _uiReducer = createReducer(initialState,
  on(actions.isLoading, state => ({ ...state, isLoading: true})),
  on(actions.stopLoading, state => ({ ...state, isLoading: false})),

);

export function uiReducer(state, action) {
  return _uiReducer(state, action);
}